import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';
import BaseBreadcrumbOption from './BaseBreadcrumbOption.js';

const ActiveSeparator = styled(MuiTypography) `
  margin: ${({ theme }) => theme.spacing(0, 2)};
`;
const Root = styled(MuiBox) `
  display: flex;
  height: 20px;
  white-space: nowrap;
`;
const BreadcrumbMock = (_a) => {
    var { withSeparator } = _a, rest = __rest(_a, ["withSeparator"]);
    return (jsxs(Root, { children: [withSeparator && jsx(ActiveSeparator, Object.assign({ variant: "h5" }, { children: "/" })), jsx(BaseBreadcrumbOption, Object.assign({}, rest))] }));
};

export { BreadcrumbMock as default };
//# sourceMappingURL=BreadcrumbMock.js.map
